/* eslint-disable no-new */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import vuetify from '@/plugins/vuetify'
import vuelayers from '@/plugins/vuelayers'

Vue.prototype.$unit = {name: 'Horw', uuid: '994d775e-b305-4c5a-a98f-852a1408cc77', processingStatus: 'NONE'}

Vue.prototype.$user = {isAuthenticated: false, name: 'Muster', surname: 'Max', role: 'editor', uid: '012312', accessToken: 'abc999'}

Vue.config.productionTip = false

localStorage.accessToken = 'abc999'

new Vue({
  vuetify,
  vuelayers,
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js